@use '../../../scss/settings/colors.scss';

.template_preview_container {
  max-width: 500px;
  font-size: 14px;
  font-weight: 400;
  color: colors.$dark-blue;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);

  h2 {
    font-family: "Bold Inter", sans-serif !important;
  }

  > div {
    margin-bottom: 8px;
  }

  > p {
    margin: 0 0 8px;
  }

}

.flex_variant {
  display: flex;
  align-items: flex-start;
  gap: 8px;

  > div {

    &:first-child {
      flex-shrink: 0;
      width: 100px;
      text-align: right;

      + div {
        flex-grow: 1;
      }

    }

  }

}
